import { Typography } from '@mui/material';

import { SummaryCard } from '../styles';

interface PoleSummaryCardProps {
  label: string;
  value: number;
  hint: string;
}

export function PoleSummaryCard({
  label,
  value,
  hint,
}: PoleSummaryCardProps): JSX.Element {
  return (
    <SummaryCard>
      <Typography color="text.secondary" fontSize={14}>
        {label}
      </Typography>
      <Typography color="text.primary" fontSize={28} fontWeight={700}>
        {value}
      </Typography>
      <Typography color="text.secondary" fontSize={13}>
        {hint}
      </Typography>
    </SummaryCard>
  );
}
